import React from 'react';
import { Menu } from 'antd';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

function LeftMenu(props) {

  const sysAdminNavigation = () => {
    if (!props.data.user.userData?.isAuth) return null;
    const items = [
      { label: (<a href="/student/users">Users</a>), key: 'users' },
      { label: (<a href="/sysadmin/schools">Schools</a>), key: 'schools' }
    ];
    return <Menu disabledOverflow={true} mode={props.mode} items={items} />;
  }

  return (
    sysAdminNavigation()
  )
}

function mapStateToProps(state) {
  return {
    data: state
  };
}

export default withRouter(connect(mapStateToProps)(LeftMenu))